module.exports = __webpack_public_path__ + "img/cert3.e300dcf5.png";